import { createReducer, createAction } from '@reduxjs/toolkit';
import { ToastManager } from 'models';

interface ToastState {
    toastList: ToastManager.ToastConfig[];
}

const initialState: ToastState = {
    toastList: [],
};

export const addToast = createAction<ToastManager.ToastConfig>('toastList/add');
export const removeToast = createAction<number>('toastList/remove');

const toastReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(addToast, (state, action) => {
            state.toastList.push(action.payload);
        })
        .addCase(removeToast, (state, action) => {
            state.toastList = state.toastList.filter(
                (toast) => toast.id !== action.payload,
            );
        });
});

export const ToastActions = {
    addToast,
    removeToast,
};

export default toastReducer;
